import { createApp } from 'vue'
import Stundenplan from './components/Stundenplan.vue'

createApp(Stundenplan).mount('#app')